
import { Component } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { HintComponent } from '@shared-angular/components/hint/hint.component';
import { AdminService } from '@shared-angular/services/admin.service';
import { RouteShareService } from 'src/app/shared/services/route-share.service';
import { ToastrService } from '@shared-angular/services/toastr.service';
import { SupervisorService } from '../../../insights/supervisor-tab/supervisor.service';

@Component({
  selector: 'app-bot-history-cleanup',
  imports: [HintComponent, ButtonModule, ConfirmDialogModule],
  templateUrl: './bot-history-cleanup.component.html',
  styleUrl: './bot-history-cleanup.component.scss',
  providers: [ConfirmationService]
})
export class BotHistoryCleanupComponent {
  constructor(
    private adminService: AdminService,
    private rssService: RouteShareService,
    private confirmationService: ConfirmationService,
    private toastr: ToastrService,
    private supervisorService: SupervisorService
  ) { }

  public confirmHistoryCleanup(): void {
    this.confirmationService.confirm({
      header: $localize`:@@delete-message-history-modalLabel:Chatverlauf löschen?`,
      message: $localize`:@@delete-message-history-modalContent:Möchtest du den Chatverlauf und damit zusammenhängende Daten unwiderruflich löschen? Diese Aktion kann nicht rückgängig gemacht werden.`,
      icon: 'ri-error-warning-line',
      rejectButtonProps: {
        label: $localize`:@@delete-reject:Abbrechen`,
        severity: 'secondary',
        outlined: true
      },
      acceptButtonProps: {
        label: $localize`:@@delete-message-history-button:Chatverlauf löschen`,
        severity: 'danger'
      },
      accept: () => { void this.historyCleanup(); }
    });
  }

  private async historyCleanup() {
    await this.adminService.historyCleanup(this.rssService.botConfig._id);
    this.supervisorService.currentActiveHelpTriggers = [];
    this.toastr.success("DELETED");
  }
}